import { createPortal } from "react-dom";
import useElementWhenReady from "../../hooks/useElementWhenReady";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { MODEL_WEARS_STORES } from "../../constants";
import ModelWears from "./ModelWears";

function shouldShowModelWears(storeCode?: string): boolean {
  return storeCode ? MODEL_WEARS_STORES.includes(storeCode) : false;
}

export default function ModelWearsPortal() {
  const { isMobile, productDescription, storeCode } = (useRuntimeConstants() ||
    {}) as {
    isMobile?: boolean;
    productDescription?: { sizeAndFit?: string };
    storeCode?: string;
  };
  const mobilePortalElement = useElementWhenReady("#model-wears-portal");
  const desktopPortalElement = useElementWhenReady(
    "#model-wears-portal-desktop"
  );

  const { sizeAndFit } = productDescription || {};
  const portalTarget = isMobile ? mobilePortalElement : desktopPortalElement;
  const shouldRender =
    portalTarget && shouldShowModelWears(storeCode) && sizeAndFit?.trim();

  if (!shouldRender) return null;

  return createPortal(<ModelWears sizeAndFit={sizeAndFit} />, portalTarget);
}
